import { createFileRoute } from "@tanstack/react-router";
import { Star } from "lucide-react";
import { BUSINESS } from "#/lib/constants";
import { ReviewSlider } from "#/components/pages/reviews";
import { HomeFAQ, FinalCTA } from "#/components/pages/home";
import { PageHeader } from "#/components/shared/PageHeader";
import { HEADER } from "#/lib/images";

const TITLE = "Reviews | Blue Rock Concrete";
const DESCRIPTION =
  "What Delaware homeowners say about our driveways, patios, stamped concrete, and garage floors. Real reviews, straight answers to common questions.";

/**
 * HIDDEN as of 2026-07-26 — mothballed, not deleted.
 *
 * The business has no real reviews yet, so a page presenting a slider of them
 * (plus a 4.9 / 60-review header) overstated things. The route still resolves
 * if you know the URL, but it is removed from NAV_LINKS, removed from
 * sitemap.xml, and `noindex` below so search cannot surface it.
 *
 * To restore when real reviews exist: drop the robots meta, restore the og/
 * canonical tags and the FAQ schema below, re-add the sitemap and NAV_LINKS
 * entries, and take `HomeFAQ` back off the home page. The FAQPage schema now
 * lives on `/` — emitting it from both places would be a duplicate.
 */
export const Route = createFileRoute("/reviews")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: ReviewsPage,
});

function ReviewsPage() {
  return (
    <main>
      <PageHeader
        eyebrow="Reviews"
        title="What Delaware homeowners say"
        intro="Real reviews from real driveways, patios, and garage floors across New Castle County."
        image={HEADER.reviews.src}
        imageMobile={HEADER.reviews.mobile}
        imageAlt={HEADER.reviews.alt}
      >
        <div className="inline-flex items-center gap-4 rounded-2xl bg-charcoal/80 px-5 py-4 ring-1 ring-white/10 backdrop-blur-sm">
          <span className="font-heading text-4xl font-extrabold text-white">
            {BUSINESS.rating}
          </span>
          <div>
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="h-4 w-4 fill-flame text-flame" />
              ))}
            </div>
            <p className="mt-1 text-xs text-concrete-light">
              {BUSINESS.reviews}+ verified Google reviews
            </p>
          </div>
        </div>
      </PageHeader>

      <ReviewSlider />

      {/* FAQ — moved here from the home page; its section carries id="faq" */}
      <HomeFAQ />

      <FinalCTA />
    </main>
  );
}
